import type { PivotDateGroupEnum } from '@ztechapps/common.contract'
import { PivotZoneEnum } from './PivotZoneEnum'

/** Drag format of an All fields list row. */
export const PIVOT_FIELD_DRAG_TYPE = 'application/x-pivot-field'

/** Drag format of a zone item — lower-cased, because DataTransfer.types lower-cases formats. */
export const toPivotZoneDragType = (zone: PivotZoneEnum): string => `application/x-pivot-zone-${zone.toLowerCase()}`

/** Payload carried by a pivot field or zone item drag. */
export type PivotFieldDragPayload = {
  field: string
  dateGroup?: PivotDateGroupEnum
  zone?: PivotZoneEnum
  index?: number
}

/** The list or another zone's drag format present in a drag over a zone — never the zone's own. */
export const findPivotFieldDragType = (types: readonly string[], zone: PivotZoneEnum): string | undefined => {
  const otherZones = Object.values(PivotZoneEnum)
    .filter((other) => other !== zone)
    .map((other) => toPivotZoneDragType(other))
  return [PIVOT_FIELD_DRAG_TYPE, ...otherZones].find((dragType) => types.includes(dragType))
}

/** A zone item's drag format present in a drag — the list's own format never matches. */
export const findPivotZoneDragType = (types: readonly string[]): string | undefined =>
  Object.values(PivotZoneEnum)
    .map(toPivotZoneDragType)
    .find((dragType) => types.includes(dragType))
